// extracted by mini-css-extract-plugin
module.exports = {"tag_button":"TagButton_tag_button__2wZCx","tag_button_title":"TagButton_tag_button_title__eKLs_"};